/* ══ THE STORY SHOP — BOOKSELLER WIDGET ══
 *
 * Drops into the theme unchanged. Configure before loading:
 *   window.BOOKSELLER = { endpoint: 'https://chat.thestoryshoplb.com/chat', cart: true }
 *
 * cart:false renders the buttons but skips the real /cart/add.js call, so the
 * widget can be driven end-to-end outside the storefront.
 */
(function () {
  'use strict';

  var CFG = Object.assign(
    { endpoint: '/chat', cart: true, greeting: null, name: 'Bookmark' },
    window.BOOKSELLER || {}
  );

  /* An open book with a spark above it — books and AI in one mark, rather than
     the generic sparkle every assistant uses. The spark is animated in CSS. */
  function icon(size) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M11.2 8.4C9.1 7.2 6.6 7.1 4 8v11c2.6-.9 5.1-.8 7.2.4"/>' +
        '<path d="M12.8 8.4C14.9 7.2 17.4 7.1 20 8v11c-2.6-.9-5.1-.8-7.2.4"/>' +
        '<path d="M12 8.8v11"/>' +
        '<path class="bs-spark" d="M12 1.4l.85 2.15L15 4.4l-2.15.85L12 7.4l-.85-2.15L9 4.4l2.15-.85z" ' +
          'fill="currentColor" stroke="none"/>' +
      '</svg>';
  }

  var OPENERS = [
    'Something like ACOTAR but darker',
    'A thriller I can finish in one sitting',
    'بدي رواية عربية حلوة',
  ];

  var GREETING =
    CFG.greeting ||
    "Hello. Tell me what you're in the mood for — a genre, an author, a book you loved — and I'll find you something from the shelves.";

  var history = [];   // what we send back to the server
  var busy = false;
  var el = {};

  /* Arabic anywhere in the text means the whole reply reads right-to-left */
  function isRtl(s) { return /[؀-ۿݐ-ݿ]/.test(s || ''); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* The model writes **bold** for titles. Escape first, then allow only that. */
  function fmt(s) {
    return esc(s).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  function build() {
    var root = document.createElement('div');
    root.className = 'bs-root';
    root.innerHTML =
      '<button class="bs-bubble" id="bsBubble" aria-label="Ask ' + esc(CFG.name) + ', the reading assistant">' +
        icon(24) +
      '</button>' +
      '<button class="bs-hello" id="bsHello" type="button">' +
        '<b>' + esc(CFG.name) + '</b>Looking for something to read?' +
      '</button>' +
      '<div class="bs-panel" id="bsPanel" role="dialog" aria-modal="false" aria-label="' + esc(CFG.name) + '">' +
        '<div class="bs-head">' +
          '<div class="bs-mark">' + icon(19) + '</div>' +
          '<div><div class="bs-head-title">' + esc(CFG.name) + '</div>' +
          '<div class="bs-head-sub">The Story Shop</div></div>' +
          '<button class="bs-close" id="bsClose" aria-label="Close">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
              '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bs-body" id="bsBody"></div>' +
        '<div class="bs-foot">' +
          '<form class="bs-form" id="bsForm">' +
            '<textarea class="bs-input" id="bsInput" rows="1" maxlength="500" ' +
              'placeholder="What are you in the mood for?" aria-label="Your message"></textarea>' +
            '<button class="bs-send" id="bsSend" type="submit" aria-label="Send">' +
              '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
                '<line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>' +
            '</button>' +
          '</form>' +
          '<p class="bs-note">Books only. For anything about an order, message us on WhatsApp.</p>' +
        '</div>' +
      '</div>';

    document.body.appendChild(root);
    el.hello = root.querySelector('#bsHello');

    el.bubble = root.querySelector('#bsBubble');
    el.panel = root.querySelector('#bsPanel');
    el.close = root.querySelector('#bsClose');
    el.body = root.querySelector('#bsBody');
    el.form = root.querySelector('#bsForm');
    el.input = root.querySelector('#bsInput');
    el.send = root.querySelector('#bsSend');
  }

  function scroll() { el.body.scrollTop = el.body.scrollHeight; }

  function addMessage(text, who) {
    var wrap = document.createElement('div');
    wrap.className = 'bs-msg ' + (who === 'user' ? 'bs-msg-out' : 'bs-msg-in');
    var b = document.createElement('div');
    b.className = 'bs-bubble-txt' + (isRtl(text) ? ' bs-rtl' : '');
    b.innerHTML = fmt(text);
    wrap.appendChild(b);
    el.body.appendChild(wrap);
    scroll();
    return wrap;
  }

  function addOpeners() {
    var box = document.createElement('div');
    box.className = 'bs-chips';
    OPENERS.forEach(function (t) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'bs-chip';
      c.textContent = t;
      if (isRtl(t)) c.setAttribute('dir', 'rtl');
      c.addEventListener('click', function () { box.remove(); send(t); });
      box.appendChild(c);
    });
    el.body.appendChild(box);
    scroll();
  }

  /* Cards are built from what the server verified against the live shop —
     never from anything the model wrote. */
  function addBooks(books) {
    if (!books || !books.length) return;
    var box = document.createElement('div');
    box.className = 'bs-books';

    books.forEach(function (b) {
      var card = document.createElement('div');
      card.className = 'bs-book';

      var img = b.image
        ? '<img class="bs-book-img" src="' + esc(b.image) + '" alt="' + esc(b.title) + '" loading="lazy">'
        : '<div class="bs-book-img"></div>';

      var label = 'Add', cls = 'bs-add', dis = '';
      if (!b.available) { label = 'Unavailable'; dis = 'disabled'; }
      else if (b.preorder) { label = 'Pre-order'; cls += ' bs-pre'; }

      card.innerHTML =
        img +
        '<div class="bs-book-info">' +
          '<div class="bs-book-title"><a href="' + esc(b.url) + '" target="_blank" rel="noopener">' +
            esc(b.title) + '</a></div>' +
          '<div class="bs-book-price">' + esc(b.price) + '</div>' +
        '</div>' +
        '<button class="' + cls + '" ' + dis + '>' + label + '</button>';

      var btn = card.querySelector('button');
      if (!dis) btn.addEventListener('click', function () { addToCart(b, btn); });
      box.appendChild(card);
    });

    el.body.appendChild(box);
    scroll();
  }

  async function addToCart(book, btn) {
    if (!book.variantId) return;
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = '...';

    try {
      if (CFG.cart) {
        var added = await window.StoryStock.add({ id: book.variantId, quantity: 1, handle: book.handle });
        if (!added) { btn.textContent = was; btn.disabled = false; return; }
        // Keep the theme's own cart in step if it is present
        if (typeof window.refreshCart === 'function') window.refreshCart();
      }
      btn.textContent = CFG.cart ? 'Added' : 'Added (test)';
      btn.classList.add('bs-added');
    } catch (e) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = was; }, 2200);
    }
  }

  function showTyping() {
    var w = document.createElement('div');
    w.className = 'bs-msg bs-msg-in';
    w.innerHTML = '<div class="bs-bubble-txt bs-typing"><i></i><i></i><i></i></div>';
    el.body.appendChild(w);
    scroll();
    return w;
  }

  async function send(text) {
    text = (text || '').trim();
    if (!text || busy) return;

    busy = true;
    el.send.disabled = true;
    el.input.value = '';
    el.input.style.height = 'auto';

    addMessage(text, 'user');
    history.push({ role: 'user', content: text });

    var typing = showTyping();

    try {
      var res = await fetch(CFG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history }),
      });
      var data = await res.json();
      typing.remove();

      var reply = data.reply || "Something went wrong on our end. Try again in a moment.";
      addMessage(reply, 'bot');
      addBooks(data.books);

      // Only real replies go back into the thread — errors would poison it
      if (res.ok && data.reply) history.push({ role: 'assistant', content: data.reply });
    } catch (e) {
      typing.remove();
      addMessage("I can't reach the shop right now. Try again in a moment.", 'bot');
    } finally {
      busy = false;
      el.send.disabled = false;
      el.input.focus();
    }
  }

  function dismissHello() {
    if (!el.hello || el.hello.classList.contains('bs-gone')) return;
    el.hello.classList.add('bs-gone');
    setTimeout(function () { el.hello.remove(); }, 300);
  }

  function open() {
    dismissHello();
    el.panel.classList.add('bs-open');
    el.bubble.classList.add('bs-hidden');
    if (!el.body.children.length) {
      addMessage(GREETING, 'bot');
      addOpeners();
    }
    setTimeout(function () { el.input.focus(); }, 260);
  }

  function close() {
    el.panel.classList.remove('bs-open');
    el.bubble.classList.remove('bs-hidden');
  }

  function init() {
    build();

    el.bubble.addEventListener('click', open);
    el.close.addEventListener('click', close);
    if (el.hello) el.hello.addEventListener('click', open);

    // The greeting says its piece, then gets out of the way
    setTimeout(dismissHello, 11000);

    el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(el.input.value);
    });

    // Enter sends, Shift+Enter makes a new line
    el.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(el.input.value); }
    });

    el.input.addEventListener('input', function () {
      el.input.style.height = 'auto';
      el.input.style.height = Math.min(el.input.scrollHeight, 96) + 'px';
      el.input.setAttribute('dir', isRtl(el.input.value) ? 'rtl' : 'ltr');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.panel.classList.contains('bs-open')) close();
    });

    window.BooksellerWidget = { open: open, close: close };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
